import { render, staticRenderFns } from "./danger.vue?vue&type=template&id=3246b3d3&scoped=true&"
import script from "./danger.vue?vue&type=script&lang=js&"
export * from "./danger.vue?vue&type=script&lang=js&"
import style0 from "./danger.vue?vue&type=style&index=0&id=3246b3d3&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3246b3d3",
  null
  
)

export default component.exports